import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import BaseLayout from "./components/BaseLayout";
import Users from "./components/Users";
import InviteUser from "./components/InviteUser";
import LoginPage from "./components/LoginPage";
import ConfirmEmail from "./components/ConfirmEmail";
import ExpiredPage from "./components/ExpiredPage";

// Helper to sync sidebar with router
function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedUser, setSelectedUser] = useState(null);

  const handleNav = (nav) => {
    if (nav === "users") {
      setSelectedUser(null); // ✅ Reset here when switching to Users tab
      navigate("/users");
    } else if (nav === "inviteUser") {
      navigate("/inviteUser");
    }
  };

  const handleResetSelectedUser = () => {
    setSelectedUser(null);
  };

  // Determine selectedNav from the path
  let selectedNav = "users";
  if (location.pathname === "/inviteUser") selectedNav = "inviteUser";
  else if (location.pathname === "/users") selectedNav = "users";

  return (
    <BaseLayout
      selectedNav={selectedNav}
      onNav={handleNav}
      onResetSelectedUser={handleResetSelectedUser}
    >
      <Routes>
        <Route path="/inviteUser" element={<InviteUser />} />
        <Route
          path="/users"
          element={
            <Users
              selectedUser={selectedUser}
              setSelectedUser={setSelectedUser}
            />
          }
        />
        <Route path="/logout" element={<div>Logging out...</div>} />
        <Route path="/" element={<Navigate to="/users" replace />} />
      </Routes>
    </BaseLayout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/users/auth/confirm" element={<ConfirmEmail />} />
        <Route path="/auth" element={<LoginPage />} />
        <Route path="/auth/error" element={<ExpiredPage />} />
        <Route path="/*" element={<AppLayout />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
